import LocationOnIcon from '@mui/icons-material/LocationOn';
import PublicIcon from '@mui/icons-material/Public';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';
import FaxIcon from '@mui/icons-material/Fax';
import Clear from '@mui/icons-material/Clear';
import { Avatar, ListItemAvatar, ListItemText, ListItem, List, Typography, Grid, Box } from '@mui/material';
import Button from '@mui/material/Button';
import {Storedirected, mapAction } from './actions';
import { useSelector, useDispatch } from 'react-redux';
const InfoIconData = () => {
    var SiteData = useSelector(state => state.SiteData);
    const popupLocation = useSelector(state => state.InfoBox);
    var dispatch = useDispatch();
    var center = useSelector(state => state.InfoBoxCenter);
    async function StoreDirection( data ) {
        var destination = data.metadata.latitude + ',' + data.metadata.longitude;
        // eslint-disable-next-line no-undef
        const directionsService = new google.maps.DirectionsService();
        const results = await directionsService.route({
            origin: center.lat + ',' + center.lng,
            destination: destination,
            // eslint-disable-next-line no-undef
            travelMode: google.maps.TravelMode.DRIVING,
            optimizeWaypoints: false,
            provideRouteAlternatives: false,
            avoidFerries: false,
            avoidHighways: false,
            avoidTolls: false,
        });
        dispatch(mapAction(results));
        dispatch(Storedirected({ clicked: true, data: data }));
    }
    const closeInfoBox =  () => {
        for ( let element of document.getElementsByClassName('rslInfobox') ){
            element.style.display="none";
        }
    }
    if ( popupLocation.length === 0 ) {
        return;
    }
    const directionBtnColor = SiteData.direction_btn_color ? SiteData.direction_btn_color : '#efefef';
    const directionBtnTextColor = SiteData.direction_btn_text_color ? SiteData.direction_btn_text_color : '#000';
    const websiteBtnColor = SiteData.website_btn_color ? SiteData.website_btn_color : '#ccc';
    const websiteBtnTextColor = SiteData.website_btn_text_color ? SiteData.website_btn_text_color : '#000';
    const titleColor = SiteData.sidebar_stores_title_color ? SiteData.sidebar_stores_title_color : '#000';
    const infomd = ('full' === SiteData.infoBoxFull) ? 12 : 8;
    const thumbnailMd = ('full' === SiteData.infoBoxFull) ? 12 : 4;
    const thumbnailClass = ('full' === SiteData.infoBoxFull) ? `rslInfoButtonsFull` : '';
    const directionBtnClass = ('full' === SiteData.infoBoxBtnFull) ? `rslInfoButtonsFull` : '';
    const websiteBtnClass = ('full' === SiteData.infoBoxBtnFull) ? `rslInfoButtonsFull` : 'rslWebsiteButton';
    return(
        <Box sx={{ flexGrow: 1 }}>
            <Grid container>
            <span className="rslClosePopup" onClick={closeInfoBox} style={{cursor:'pointer'}}><Clear /></span>
            <Typography style={{width:'100%', color:titleColor}}>{(popupLocation.length !== 0) ? popupLocation.title.rendered : ''}</Typography>
            <Grid item xs={12} md={infomd} className="description">{<Typography>{(popupLocation.length !== 0) ? popupLocation.metadata.fulladdress : ''}</Typography>}
                <div className="rslMarkerinfo">
                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} >
                        <ListItem>
                            <ListItemAvatar style={{minWidth:'30px'}}>
                                <Avatar sx={{ width: 24, height: 24 }}>
                                    <MailIcon sx={{ fontSize: 14 }} />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText style={{fontSize:'8px'}} primary={<Typography>{(popupLocation.length !== 0) ? popupLocation.metadata.email : ''}</Typography>} />
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar style={{minWidth:'30px'}}>
                                <Avatar sx={{ width: 24, height: 24 }}>
                                    <LocationOnIcon sx={{ fontSize: 14 }} />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={<Typography>{(popupLocation.length !== 0) ? popupLocation.metadata.email : ''}</Typography>} />
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar style={{minWidth:'30px'}}>
                                <Avatar sx={{ width: 24, height: 24 }}>
                                    <FaxIcon sx={{ fontSize: 14 }} />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={<Typography>{(popupLocation.length !== 0) ? popupLocation.metadata.fax : ''}</Typography>} />
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar style={{minWidth:'30px'}}>
                                <Avatar sx={{ width: 24, height: 24 }}>
                                    <PublicIcon sx={{ fontSize: 14 }} />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={<Typography>{(popupLocation.length !== 0) ? popupLocation.metadata.website : ''}</Typography>} />
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar style={{minWidth:'30px'}}>
                                <Avatar sx={{ width: 24, height: 24 }}>
                                    <PhoneIcon sx={{ fontSize: 14 }} />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={<Typography>{(popupLocation.length !== 0) ? popupLocation.metadata.phone : ''}</Typography>} />
                        </ListItem>
                    </List>
                </div>
            </Grid>
            <Grid item xs={12} md={thumbnailMd} className="thumbnail"><img className={thumbnailClass} src={(popupLocation.length !== 0) ? popupLocation.metadata.thumbnail : ''} width={100} alt="marker" /></Grid>
            <Button className={directionBtnClass} onClick={() => StoreDirection(popupLocation)} style={{background:directionBtnColor, color:directionBtnTextColor, marginRight:'10px'}}>{SiteData.label_direction_btn ? SiteData.label_direction_btn : 'Direction'}</Button>
            {popupLocation.metadata.website ? <a className={websiteBtnClass} style={{background:websiteBtnColor, color:websiteBtnTextColor}} href={popupLocation.metadata.website}>{SiteData.label_website ? SiteData.label_website : 'Website'}</a> : ''}
            </Grid>
        </Box>
    )
}
export default InfoIconData;